import {useContext, useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import { LoaderNew } from './LoaderNew'

import AlertError from '../componentsRef/AlertError/AlertError'
import {AuthContext} from '../context'
import {NewInputModuleLogin} from './NewInputModuleLogin'

import Banner1Login from '../assets/img/Banner1Login.png'
import Banner2Login from '../assets/img/Banner2Login.png'
import FullNegroVerde from '../assets/img/Full_Negro+Verde.svg'
import '../assets/css/LoginNew.css'
import { Mail, Lock, ChevronRight } from 'lucide-react'

const validationSchema = Yup.object({
	email: Yup.string()
		// .email('Ingresa con tu email y contraseña')
		// .required('Ingresa con tu email y contraseña'),
		,
	password: Yup.string().required('La contraseña es requerida').min(1),
})

export const LoginNew = () => {
	const {login, authState} = useContext(AuthContext)
	const [activeScreen, setActiveScreen] = useState(false)
	const navigate = useNavigate()
	const [isInputFocused, setInputFocused] = useState(false)
	const [loader, setLoader] = useState(false)

	const handleInputFocus = () => {
		setInputFocused(!isInputFocused)
	}

	const formik = useFormik({
		initialValues: {
			email: '',
			password: '',
		},
		validationSchema,
		onSubmit: async (values, {setSubmitting}) => {
			setLoader(true)
			const {email, password} = values
			try {
				const loginSuccess = await login(email, password)
				if (loginSuccess) {
					navigate('/HomeNew', {replace: true})
				} else {
					alert("Ha ocurrido un error, intente nuevamente o contacte al administrador.")
				}

				// window.location.pathname = '/HomeNew';
			} catch (error) {
				alert("Ha ocurrido un error, intente nuevamente o contacte al administrador.")
				console.log(error)
			}
			setLoader(false)
		},
	}, [authState])

	useEffect(() => {
		setTimeout(() => {
			setActiveScreen(true)
		}, 200)
	}, [])

	return (
		<>
		{loader && <LoaderNew />}
		<div className={`LoginNew LoginNewPure ${activeScreen && 'login_active'}`}>
			
			<img src={Banner1Login} alt='' className='Banner1Login' />
			<img src={Banner2Login} alt='' className='Banner2Login' />
			<form noValidate onSubmit={
				
					// setLoader(true)
					formik.handleSubmit
				}>
				<div className='top_box'>
					<img src={FullNegroVerde} alt='' />
				</div>
				<div className='body_area'>
					<p>Iniciar Sesión</p>
					<div className='input_wrapper'>
						<div>
							{/* <label htmlFor='email'>Correo electrónico</label> */}
							<NewInputModuleLogin
								type='email'
								id='email'
								name='email'
								placeholder='Ingresa tu Correo'
								value={formik.values.email}
								onChange={formik.handleChange}
								// onBlur={formik.handleBlur}
								// error={formik.errors.email}
								onFocus={handleInputFocus}
							/>
						</div>

						<Mail size={12} className='login-icons' color='#ADADAD' />
					</div>

					<div className='input_wrapper' style={{marginTop: 0}}>
						{/* <label htmlFor='Contraseña'>Contraseña</label> */}
						<NewInputModuleLogin
							type='password'
							id='password'
							name='password'
							placeholder='Ingresa tu Contraseña'
							value={formik.values.password}
							onChange={formik.handleChange}
							// onBlur={formik.handleBlur}
							// error={formik.errors.password}
							onFocus={handleInputFocus}
						/>

						<Lock size={12} className='login-icons' color='#ADADAD' />
					</div>

					<label className='login-new-checkbox' htmlFor='login-new'>
						<br></br>
					</label>
	
{ /*
					{(formik.touched.email && formik.errors.email) ||
					(formik.touched.password && formik.errors.password) ? (
						<Alert />
					) : null}
					*/ }

					

					<div className='input_wrapper button_wrapper' style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						textAlign: 'center',
					}}>
						<button type='submit' disabled={formik.isSubmitting}>
							Entrar
							<ChevronRight size={16} color='white' />
						</button>
						<Link to='/ForgetPasswordNew'>Olvidé mi contraseña</Link>
					</div>
					<div >
						{authState.errorMessage ? <AlertError /> : null}
					</div>
				</div>
			</form>
		</div>
		</>
	)
}
